// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';
import { Box, Grid, Button, VStack, Wrap, Flex } from '@chakra-ui/react';
import { MultiInfoCard } from 'components';
import { ChartCard } from 'components';
import { MapCard } from 'components';
import { DataTable } from 'components';
import { HorizontalBar } from 'components';
import InfoCard from 'components/Cards/InfoCard';
import SwitchCard from 'components/Cards/SwitchCard';
import BarChart from 'components/Charts/BarChart';
import LineChart from 'components/Charts/LineChart';
import MultiChart from 'components/Charts/MultiChart';
import SimpleInput from 'components/SimpleInput';
import {
  homeCardsData,
  multiChartDefaultColorsLinesAndBars,
  testLabels,
  barDataWithBorderColorAndColorArray,
  barDataWithColorArray,
  barDataWithDefaultColors,
  barDataWithDefaultColorsAndTwoDatasets,
  barDataWithOneColor,
  lineDataWithBorderColorAndColorArray,
  lineDataWithBorderColorAndTwoDatasets,
  lineDataWithColorArray,
  lineDataWithDefaultColors,
  lineDataWithOneColor,
  multiChartDefaultColorsBars,
  multiChartDefaultColorsLines,
  multiChartWithColorsBarsAndLinesAndBorderColors,
  multiChartWithColorsBarsStackedAndLines,
  MapValue1,
  MapValue2,
} from 'utils/constants';

type Data = {
  itens: Record<string, string | number>[];
  pageCount: number;
  rows: number;
};

const data: Data = {
  itens: [],
  pageCount: 100,
  rows: 100,
};

for (let index = 0; index < 50; index++) {
  data.itens.push({
    id: index,
    dado: Math.floor(Math.random() * 999),
    botao: `Botão ${index}`,
    dado1: Math.floor(Math.random() * 999),
    tag: ['Paga', 'Em análise', 'Recorrida'][Math.floor(Math.random() * 3)],
    dado2: Math.floor(Math.random() * 999),
    dado3: Math.floor(Math.random() * 999),
    dado4: Math.floor(Math.random() * 999),
  });
}

const testTableLabels = [
  {
    title: 'Id',
    type: 'data',
    accessor: 'id',
  },
  {
    title: 'Dado',
    type: 'data',
    accessor: 'dado',
  },
  {
    title: 'Botão',
    type: 'button',
    // eslint-disable-next-line no-console
    ButtonFn: ({ id }: { id: string }) => console.log(id),
    accessor: 'botao',
  },
  {
    title: 'Dado 1',
    type: 'data',
    accessor: 'dado1',
  },
  {
    title: 'Tag',
    type: 'tag',
    accessor: 'tag',
  },
  {
    title: 'Dado 2',
    type: 'data',
    accessor: 'dado2',
  },
  {
    title: 'Dado 3',
    type: 'data',
    isShown: false,
    accessor: 'dado3',
  },
  {
    title: 'Dado 4',
    type: 'data',
    isShown: false,
    accessor: 'dado4',
  },
];

const testFilters = [
  {
    label: 'Id',
    type: 'text',
    placeholder: 'Todas',
    accessor: 'id',
  },
  {
    label: 'Botão',
    type: 'text',
    placeholder: 'Todos',
    accessor: 'botao',
  },
  {
    label: 'Tag',
    type: 'select',
    placeholder: 'Selecione a Tag',
    accessor: 'tag',
  },
];

export const Examples: React.FC = () => (
  <VStack flex={1} bg="white" textAlign="center" fontSize="xl">
    <VStack mt={4}>
      <MapCard
        w={1065}
        select={['Sudeste', 'Sul', 'Norte', 'Nordeste', 'Centro-Oeste']}
        hasMap
        hasBars
        title="Regiões por Idade e Km - Brasil"
        subtitle="A Idade e Km da sua frota dividida pelo Brasil."
        data={MapValue1}
      />
      <MapCard
        w={523}
        hasMap
        hasBars
        title="Regiões por Idade e Km - Brasil"
        subtitle="A Idade e Km da sua frota dividida pelo Brasil."
        data={MapValue1}
      />
      <MapCard
        w={523}
        hasMap
        title="Regiões por Idade e Km - Brasil"
        subtitle="A Idade e Km da sua frota dividida pelo Brasil."
        data={MapValue2}
      />
      <HorizontalBar h="22px" w="323px" total={141} value={98} />
      <Button>Default</Button>
      <Button variant="disable">Disable</Button>
      <Button variant="outline">Outline</Button>
      <VStack w="50dvw">
        <SimpleInput placeholder="CNPJ" />
        <SimpleInput isDisabled placeholder="CNPJ" />
        <SimpleInput
          backgroundColor="#1E1E1E"
          variant="dark"
          placeholder="CNPJ"
        />
        <MapCard
          w={523}
          hasMap
          hasBars
          title="Regiões por Idade e Km - Brasil"
          subtitle="A Idade e Km da sua frota dividida pelo Brasil."
          data={MapValue1}
        />
        <MapCard
          w={523}
          hasMap
          title="Regiões por Idade e Km - Brasil"
          subtitle="A Idade e Km da sua frota dividida pelo Brasil."
          data={MapValue2}
        />
        <HorizontalBar h="22px" w="323px" total={141} value={98} />
        <Button>Default</Button>
        <Button variant="disable">Disable</Button>
        <Button variant="outline">Outline</Button>
        <VStack w="50dvw">
          <SimpleInput placeholder="CNPJ" />
          <SimpleInput isDisabled placeholder="CNPJ" />
          <SimpleInput
            backgroundColor="#1E1E1E"
            variant="dark"
            placeholder="CNPJ"
          />
          <SimpleInput
            isDisabled
            backgroundColor="#1E1E1E"
            variant="dark"
            placeholder="CNPJ"
          />
          <SimpleInput placeholder="Senha" type="password" />
          <SimpleInput placeholder="Senha" isDisabled type="password" />
          <SimpleInput
            backgroundColor="#1E1E1E"
            variant="dark"
            placeholder="Senha"
            type="password"
          />
          <SimpleInput
            backgroundColor="#1E1E1E"
            variant="dark"
            placeholder="Senha"
            isDisabled
            type="password"
          />
        </VStack>
        <MultiInfoCard
          title={homeCardsData.MultiInfoData1.title}
          subtitle={homeCardsData.MultiInfoData1.subtitle}
          hasFilter={homeCardsData.MultiInfoData1.hasFilter}
          picker={homeCardsData.MultiInfoData1.picker}
          details={homeCardsData.MultiInfoData1.details}
          data={homeCardsData.MultiInfoData1.data}
        />
        <MultiInfoCard
          title={homeCardsData.MultiInfoData2.title}
          subtitle={homeCardsData.MultiInfoData2.subtitle}
          hasFilter={homeCardsData.MultiInfoData2.hasFilter}
          details={homeCardsData.MultiInfoData2.details}
          data={homeCardsData.MultiInfoData2.data}
        />
        <MultiInfoCard
          title={homeCardsData.MultiInfoData3.title}
          subtitle={homeCardsData.MultiInfoData3.subtitle}
          hasFilter={homeCardsData.MultiInfoData3.hasFilter}
          details={homeCardsData.MultiInfoData3.details}
          data={homeCardsData.MultiInfoData3.data}
        />
        <MultiInfoCard
          title={homeCardsData.MultiInfoData2.title}
          subtitle={homeCardsData.MultiInfoData2.subtitle}
          hasFilter={homeCardsData.MultiInfoData2.hasFilter}
          details={homeCardsData.MultiInfoData2.details}
          data={homeCardsData.MultiInfoData2.data}
          maxW="60%"
        />
        <MultiInfoCard
          title={homeCardsData.MultiInfoData3.title}
          subtitle={homeCardsData.MultiInfoData3.subtitle}
          hasFilter={homeCardsData.MultiInfoData3.hasFilter}
          details={homeCardsData.MultiInfoData3.details}
          data={homeCardsData.MultiInfoData3.data}
          w="100%"
          h="300px"
        />
        <Wrap justify="center">
          <MultiInfoCard
            title={homeCardsData.MultiInfoData3.title}
            subtitle={homeCardsData.MultiInfoData3.subtitle}
            picker={homeCardsData.MultiInfoData3.picker}
            hasFilter={homeCardsData.MultiInfoData3.hasFilter}
            details={homeCardsData.MultiInfoData3.details}
            data={homeCardsData.MultiInfoData3.data}
          />
          <MultiInfoCard
            title={homeCardsData.MultiInfoData3.title}
            subtitle={homeCardsData.MultiInfoData3.subtitle}
            hasFilter={homeCardsData.MultiInfoData3.hasFilter}
            details={homeCardsData.MultiInfoData3.details}
            data={homeCardsData.MultiInfoData3.data}
          />
        </Wrap>
        <ChartCard
          title={homeCardsData.MultiInfoData3.title}
          subtitle={homeCardsData.MultiInfoData3.subtitle}
          hasFilter={homeCardsData.MultiInfoData3.hasFilter}
          details={homeCardsData.MultiInfoData3.details}
          w="100%"
        >
          <Flex justifyContent="space-evenly" flex={1}>
            <Box w="45%">
              <LineChart labels={testLabels} data={lineDataWithOneColor} />
            </Box>
            <Box w="45%">
              <LineChart
                labels={testLabels}
                data={lineDataWithBorderColorAndColorArray}
              />
            </Box>
          </Flex>
        </ChartCard>
        <ChartCard
          title={homeCardsData.MultiInfoData2.title}
          subtitle={homeCardsData.MultiInfoData2.subtitle}
          hasFilter={homeCardsData.MultiInfoData2.hasFilter}
          details={homeCardsData.MultiInfoData2.details}
          w="100%"
        >
          <Flex justifyContent="space-evenly" flex={1}>
            <Box w="45%">
              <MultiChart
                labels={testLabels}
                data={multiChartDefaultColorsLinesAndBars}
                type="bar"
              />
            </Box>
            <Box w="45%">
              <BarChart
                labels={testLabels}
                stackedY={true}
                data={barDataWithDefaultColorsAndTwoDatasets}
              />
            </Box>
          </Flex>
        </ChartCard>
        <Wrap justify="center">
          <SwitchCard
            title="Frotas à disposição"
            data={homeCardsData.fleetData}
          />
          <InfoCard
            title="Valor de Locação"
            subtitle="Locação"
            data={homeCardsData.totalValueData}
          />
          <InfoCard
            title="Multas Total"
            subtitle="Valor pendente"
            data={homeCardsData.ticketData}
          />
          <InfoCard
            title="Locações Atuais"
            subtitle="Valor pendente"
            data={homeCardsData.rentalData}
          />
          <InfoCard
            title="Manutenções"
            subtitle="Valor pendente"
            data={homeCardsData.maintenanceData}
            navigate="maintance"
          />
        </Wrap>
        <Wrap justify="center">
          <MultiChart
            labels={testLabels}
            data={multiChartDefaultColorsLinesAndBars}
            type="bar"
          />
          <MultiChart
            labels={testLabels}
            data={multiChartDefaultColorsLines}
            type="line"
          />
          <MultiChart
            labels={testLabels}
            data={multiChartDefaultColorsBars}
            type="bar"
          />
          <MultiChart
            labels={testLabels}
            options={{
              scales: { x: { stacked: true, grid: { display: false } } },
            }}
            data={multiChartWithColorsBarsStackedAndLines}
            type="line"
          />
          <MultiChart
            labels={testLabels}
            options={{
              scales: { x: { grid: { display: false } } },
            }}
            data={multiChartWithColorsBarsAndLinesAndBorderColors}
            type="line"
          />
        </Wrap>
        <Wrap justify="center">
          <LineChart labels={testLabels} data={lineDataWithDefaultColors} />
          <LineChart labels={testLabels} data={lineDataWithColorArray} />
          <LineChart
            fill={false}
            labels={testLabels}
            data={lineDataWithDefaultColors}
          />
          <LineChart
            fill={false}
            labels={testLabels}
            data={lineDataWithBorderColorAndTwoDatasets}
          />
          <LineChart labels={testLabels} data={lineDataWithOneColor} />
          <LineChart
            labels={testLabels}
            data={lineDataWithBorderColorAndColorArray}
          />
        </Wrap>
        <Wrap justify="center">
          <BarChart labels={testLabels} data={barDataWithDefaultColors} />
          <BarChart
            labels={testLabels}
            data={barDataWithDefaultColorsAndTwoDatasets}
          />
          <BarChart
            labels={testLabels}
            stackedX={true}
            data={barDataWithDefaultColorsAndTwoDatasets}
          />
          <BarChart labels={testLabels} data={barDataWithColorArray} />
          <BarChart labels={testLabels} data={barDataWithOneColor} />
          <BarChart
            labels={testLabels}
            data={barDataWithBorderColorAndColorArray}
          />
        </Wrap>
      </VStack>
      <MultiInfoCard
        title={homeCardsData.MultiInfoData1.title}
        subtitle={homeCardsData.MultiInfoData1.subtitle}
        hasFilter={homeCardsData.MultiInfoData1.hasFilter}
        picker={homeCardsData.MultiInfoData1.picker}
        details={homeCardsData.MultiInfoData1.details}
        data={homeCardsData.MultiInfoData1.data}
      />
      <MultiInfoCard
        title={homeCardsData.MultiInfoData2.title}
        subtitle={homeCardsData.MultiInfoData2.subtitle}
        hasFilter={homeCardsData.MultiInfoData2.hasFilter}
        details={homeCardsData.MultiInfoData2.details}
        data={homeCardsData.MultiInfoData2.data}
      />
      <MultiInfoCard
        title={homeCardsData.MultiInfoData3.title}
        subtitle={homeCardsData.MultiInfoData3.subtitle}
        hasFilter={homeCardsData.MultiInfoData3.hasFilter}
        details={homeCardsData.MultiInfoData3.details}
        data={homeCardsData.MultiInfoData3.data}
      />
      <MultiInfoCard
        title={homeCardsData.MultiInfoData2.title}
        subtitle={homeCardsData.MultiInfoData2.subtitle}
        hasFilter={homeCardsData.MultiInfoData2.hasFilter}
        details={homeCardsData.MultiInfoData2.details}
        data={homeCardsData.MultiInfoData2.data}
        maxW="60%"
      />
      <MultiInfoCard
        title={homeCardsData.MultiInfoData3.title}
        subtitle={homeCardsData.MultiInfoData3.subtitle}
        hasFilter={homeCardsData.MultiInfoData3.hasFilter}
        details={homeCardsData.MultiInfoData3.details}
        data={homeCardsData.MultiInfoData3.data}
        w="100%"
        h="300px"
      />
      <Wrap justify="center">
        <MultiInfoCard
          title={homeCardsData.MultiInfoData3.title}
          subtitle={homeCardsData.MultiInfoData3.subtitle}
          picker={homeCardsData.MultiInfoData3.picker}
          hasFilter={homeCardsData.MultiInfoData3.hasFilter}
          details={homeCardsData.MultiInfoData3.details}
          data={homeCardsData.MultiInfoData3.data}
        />
        <MultiInfoCard
          title={homeCardsData.MultiInfoData3.title}
          subtitle={homeCardsData.MultiInfoData3.subtitle}
          hasFilter={homeCardsData.MultiInfoData3.hasFilter}
          details={homeCardsData.MultiInfoData3.details}
          data={homeCardsData.MultiInfoData3.data}
        />
      </Wrap>
      <ChartCard
        title={homeCardsData.MultiInfoData3.title}
        subtitle={homeCardsData.MultiInfoData3.subtitle}
        hasFilter={homeCardsData.MultiInfoData3.hasFilter}
        details={homeCardsData.MultiInfoData3.details}
        w="100%"
      >
        <Flex justifyContent="space-evenly" flex={1}>
          <Box w="45%">
            <LineChart labels={testLabels} data={lineDataWithOneColor} />
          </Box>
          <Box w="45%">
            <LineChart
              labels={testLabels}
              data={lineDataWithBorderColorAndColorArray}
            />
          </Box>
        </Flex>
      </ChartCard>
      <ChartCard
        title={homeCardsData.MultiInfoData2.title}
        subtitle={homeCardsData.MultiInfoData2.subtitle}
        hasFilter={homeCardsData.MultiInfoData2.hasFilter}
        details={homeCardsData.MultiInfoData2.details}
        w="100%"
      >
        <Flex justifyContent="space-evenly" flex={1}>
          <Box w="45%">
            <MultiChart
              labels={testLabels}
              data={multiChartDefaultColorsLinesAndBars}
              type="bar"
            />
          </Box>
          <Box w="45%">
            <BarChart
              labels={testLabels}
              stackedX={true}
              data={barDataWithDefaultColorsAndTwoDatasets}
            />
          </Box>
        </Flex>
      </ChartCard>
      <Wrap justify="center">
        <SwitchCard
          title="Frotas à disposição"
          data={homeCardsData.fleetData}
        />
        <InfoCard
          title="Valor de Locação"
          subtitle="Locação"
          data={homeCardsData.totalValueData}
        />
        <InfoCard
          title="Multas Total"
          subtitle="Valor pendente"
          data={homeCardsData.ticketData}
        />
        <InfoCard
          title="Locações Atuais"
          subtitle="Valor pendente"
          data={homeCardsData.rentalData}
        />
        <InfoCard
          title="Manutenções"
          subtitle="Valor pendente"
          data={homeCardsData.maintenanceData}
          navigate="maintance"
        />
      </Wrap>
      <Wrap justify="center">
        <MultiChart
          labels={testLabels}
          data={multiChartDefaultColorsLinesAndBars}
          type="bar"
        />
        <MultiChart
          labels={testLabels}
          data={multiChartDefaultColorsLines}
          type="line"
        />
        <MultiChart
          labels={testLabels}
          data={multiChartDefaultColorsBars}
          type="bar"
        />
        <MultiChart
          labels={testLabels}
          options={{
            scales: { x: { stacked: true, grid: { display: false } } },
          }}
          data={multiChartWithColorsBarsStackedAndLines}
          type="line"
        />
        <MultiChart
          labels={testLabels}
          options={{
            scales: { x: { grid: { display: false } } },
          }}
          data={multiChartWithColorsBarsAndLinesAndBorderColors}
          type="line"
        />
      </Wrap>
      <DataTable
        w={200}
        overflowX="scroll"
        filters={testFilters}
        labels={testTableLabels}
        data={data}
      />
      <DataTable
        w="100%"
        filters={testFilters}
        labels={testTableLabels}
        data={data}
      />
      <DataTable hasActions labels={testTableLabels} data={data} />
      <DataTable
        isPaginated={false}
        hasActions
        labels={testTableLabels}
        data={data}
      />
      <Wrap justify="center">
        <LineChart labels={testLabels} data={lineDataWithDefaultColors} />
        <LineChart labels={testLabels} data={lineDataWithColorArray} />
        <LineChart
          fill={false}
          labels={testLabels}
          data={lineDataWithDefaultColors}
        />
        <LineChart
          fill={false}
          labels={testLabels}
          data={lineDataWithBorderColorAndTwoDatasets}
        />
        <LineChart labels={testLabels} data={lineDataWithOneColor} />
        <LineChart
          labels={testLabels}
          data={lineDataWithBorderColorAndColorArray}
        />
      </Wrap>
      <Wrap justify="center">
        <BarChart labels={testLabels} data={barDataWithDefaultColors} />
        <BarChart
          labels={testLabels}
          data={barDataWithDefaultColorsAndTwoDatasets}
        />
        <BarChart
          labels={testLabels}
          stackedY={true}
          data={barDataWithDefaultColorsAndTwoDatasets}
        />
        <BarChart labels={testLabels} data={barDataWithColorArray} />
        <BarChart labels={testLabels} data={barDataWithOneColor} />
        <BarChart
          labels={testLabels}
          data={barDataWithBorderColorAndColorArray}
        />
      </Wrap>
    </VStack>
    <Grid minH="100vh" p={3}>
      <Button>Default</Button>
      <Button variant="disable">Disable</Button>
      <Button variant="outline">Outline</Button>
    </Grid>
  </VStack>
);
